import { SearchResultComponent } from './search-result/search-result.component';
import { RouterModule } from '@angular/router';
import { MeetingManagerComponent } from './meeting-manager/meeting-manager.component';
import { NgModule } from '@angular/core';
import { BoardsComponent } from './boards/boards.component';
import { GoogleDisclosureComponent } from './google-disclosure/google-disclosure.component';


@NgModule({
    imports: [
        RouterModule.forChild([
            { path: '', component: MeetingManagerComponent },
            { path: 'meeting-manager/:meetingId/:recurringId', component: MeetingManagerComponent },
            { path: 'search-result', component: SearchResultComponent },
            { path: 'boards', component: BoardsComponent },
            { path: 'boards/:boardId', component: BoardsComponent },
            { path: 'google-disclosure', component: GoogleDisclosureComponent }
        ])
    ],
    exports: [
        RouterModule
    ]
})
/**
 * Routing for the app config component.
 */

 export  class MeetingManagerRoutingModule {

 }
